import { useId } from 'react'

import * as S from './checkbox.styles'

import { ICheckboxProps } from './checkbox.types'

const Checkbox = ({ checked, variant = 'primary', color = 'black', ...props }: ICheckboxProps) => {
  const inputId = useId()

  return (
    <S.Container htmlFor={inputId} variant={variant} color={color}>
      <S.Input id={inputId} checked={checked} type="checkbox" {...props} />
      {checked && <S.Check />}
    </S.Container>
  )
}

export { Checkbox }
